import React, { Component } from 'react'
import { withApollo } from 'react-apollo'
import PropTypes from 'prop-types'
import { Upload, Form, Button, Input, Typography } from 'antd'

const { Text, Title } = Typography

class InputForm extends Component {
	state = {
		file: undefined,
		phone: false,
	}

	onChange = async (e) => {
		let phonenumber = e.target.value
		let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[,-\s\./0-9]*$/;
		if(re.test(e.target.value)){
			// await this.setState({phone:true})
			// await this.props.onChangePhone(phonenumber)
		}
		else if (!e.target.value) {
			// this.props.onChangePhone(false)
		}
		else{	
			// await this.setState({phone:false})
			// this.props.onChangePhone(null)
		}
	}

	onChangeText = async (e) =>{
		const { onChangeValueManageuser, name } = this.props
		onChangeValueManageuser(e.target.value, name)
	}

	// componentDidMount() {
	// 	let re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[,-\s\./0-9]*$/;
	// 	console.log("re.test('a')",re.test('11-,1a'));
	// }

	render() {
		const { value, required, name, label, mode, placeholder, onChangeInput = '', comment = "", disabled=false } = this.props
		const { getFieldDecorator } = this.props.form;
		return (
			<>
				<Form.Item label={label} className="mb-0">
					{
						mode == "number" &&
						<>
							{ getFieldDecorator(name, {
								initialValue: value,
								rules:  [{ 
									required, 
									message: 'กรุณากรอกหรือเลือก '+label,
								}],
							})(
								<Input 
									disabled={disabled}
									className='block-news'
									onChange={this.onChange} 
								/>
							)}
						</>
						||
						<>
							{ getFieldDecorator(name, {
								initialValue: value,
								rules:  [{ 
									required, 
									message: 'กรุณากรอกหรือเลือก '+label,
								}],
							})(
								<Input 
									className='block-news' 
									disabled={disabled}
								/>
							)}
						</>
					}
					{
						comment &&
						<Text> { comment }</Text>
					}
				</Form.Item>
			</>
		)
	}
}

InputForm.defaultProps = {
	autoFocus: false
}

InputForm.propTypes = {
	afterSubmit: PropTypes.func,
	forgotLink: PropTypes.string,
	autoFocus: PropTypes.bool
}

const WrappedInputForm = Form.create()(InputForm)

export default withApollo(WrappedInputForm)